// import Definition from './Definition';

export default {
  priority: 13,
  path: 'assignment',
  permissions: ['TimeAttendanceMenu/'],
  // component: Definition,
  component: load(() => import(/* webpackChunkName: "Shift-Definition" */ './Assignment')),
  name: app.translate('routes.home.attendance.shift.Assignment'),
  icon: 'account-check',
  drawer: true,
};


